import { asAmount } from "@goodfill/domain-properties";
import { HoldingValueComponent } from "@goodfill/domain-properties-components";
import { formatCurrencyAmount } from "@goodfill/format-number";
import { Flex, Span, Field, Chip } from "@goodfill/ui-components";
import Decimal from "decimal.js";
import { useState } from "react";
import { UserAuthDataBalanceAccount } from "../../../backendApi/amplifyGraphQl/CustomGetUserData/UserData";
import { AccountBondHolding, AccountBondHoldingValuation } from "../../AccountHolding";

export const PortfolioSummary = (props: {
  moneyBalanceAccount: UserAuthDataBalanceAccount;
  bondHoldings: AccountBondHolding[];
}) => {
  const [valuation, setValuation] = useState<AccountBondHoldingValuation>("bid");

  const changeToValuation = (_valuation: AccountBondHoldingValuation) => () => setValuation(_valuation);

  const totalBondValue = props.bondHoldings.reduce((acc, bondHolding) => {
    return acc.plus(bondHolding.getBondValue(valuation));
  }, new Decimal(0));

  const currency = props.moneyBalanceAccount.currency;
  if (currency === null) {
    return <>Error: missing currency in moneyBalanceAccount</>;
  }

  const balance = props.moneyBalanceAccount.balance;
  const disponibleBalance = props.moneyBalanceAccount.disponibleBalance;
  const fundsOnHold = balance.minus(disponibleBalance);

  const totalPortfolioAmount = asAmount(balance.plus(totalBondValue));

  return (
    <Flex direction="col" width={96}>
      <Flex direction="row" items="center" justify="between" verticalMargin={4}>
        <Span font="semibold" size="lg">
          Summary
        </Span>
      </Flex>
      <Flex direction="col" horizontalPadding={2}>
        <Field label="Valuation">
          <Flex>
            <Chip font="medium" size="small" primary={valuation === "bid"} onClick={changeToValuation("bid")}>
              Bid
            </Chip>
            <Chip font="medium" primary={valuation === "mid"} size="small" onClick={changeToValuation("mid")}>
              Mid
            </Chip>
          </Flex>
        </Field>
        <Field label="Total Bond Value">
          <Span font="medium">
            {formatCurrencyAmount({
              value: totalBondValue.toFixed(0),
              numDecimals: 0,
              currency,
            })}
          </Span>
        </Field>
        <Field label="Open Orders">
          <Span font="medium">
            {formatCurrencyAmount({
              value: fundsOnHold.toFixed(0),
              numDecimals: 0,
              currency,
            })}
          </Span>
        </Field>
        <Field label="Current Cash Balance">
          <Span font="medium">
            {formatCurrencyAmount({
              value: disponibleBalance.toFixed(2),
              numDecimals: 2,
              currency,
            })}
          </Span>
        </Field>
        <Field label="Total">
          <Span font="medium">
            <HoldingValueComponent value={totalPortfolioAmount} currency={currency} />
          </Span>
        </Field>
      </Flex>
    </Flex>
  );
};
